import { t } from '@lingui/core/macro'
import { defineEntityConfig } from '@pkg/db/schema/EntityConfig'
import { FaUser } from 'react-icons/fa6'
import { formatUserName, UserSchema } from './schema/User'

export const UserConfig = defineEntityConfig(() => ({
  schema: UserSchema,

  label: t`Mitarbeiter:in`,
  labelPlural: t`Mitarbeiter:innen`,

  icon: FaUser,

  route: {
    list: '/mitarbeiter',
    edit: '/mitarbeiter/$id',
  },

  relationSelectionColumns: [
    {
      title: t`Name`,
      key: 'name',
      render: (_, record) => formatUserName(record),
    },
    {
      title: t`Telefon`,
      key: 'phone',
      render: (_, record) => record.phone,
    },
    {
      title: t`Mobil`,
      key: 'mobile',
      render: (_, record) => record.mobile,
    },
  ],

  search: {
    sortableFields: ['firstName', 'lastName', 'createdAt'] as const,
    defaultSortBy: 'lastName',
    defaultSortOrder: 'asc',
  },

  format: {
    primary: val => (val ? formatUserName(val) : undefined),
    secondary: val => val?.phone,
  },
}))
